module.exports = __webpack_public_path__ + "img/BotonPSE.8ce04e0d.png";